<template>
	<v-app id="app" :dark="$store.getters.getTheme">
		<router-view></router-view>
	</v-app>
</template>

<script>
export default {
	data() {
		return {

		}
	}
}
</script>
